import { library } from '@fortawesome/fontawesome-svg-core';

// import { } from '@fortawesome/free-regular-svg-icons'

// import { } from '@fortawesome/free-solid-svg-icons';

// import { } from '@fortawesome/free-brands-svg-icons';

import {
    faMale, faImages
} from '@fortawesome/free-solid-svg-icons';

library.add([
    faMale, faImages
]);



// WEBPACK FOOTER //
// ./resources/js/core/structure/menu/icons/app.js